import {
  SearchOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  notification,
  PageHeader,
  Row,
  Col,
  Input,
  DatePicker,
} from "antd";
import { useState } from "react";

import { useAuth } from "../../context/auth";
import MerchantDropdown from "../Dropdown/MerchantDropdown";
import LandlordDropdown from "../Dropdown/LandlordDropdown";
import IconReport from "../../static/icon/IconReport";

const UserPromotionReport = () => {
  const { accessToken } = useAuth();

  const [form] = Form.useForm();
  const selectedMerchants = Form.useWatch('merchantIds', form);

  const [loading, setLoading] = useState(false);

  async function download(searchValue) {
    setLoading(true);

    const url = new URL('/api/report/user-promotion', window.location);
    if (searchValue.firstName) url.searchParams.append('firstName', searchValue.firstName);
    if (searchValue.lastName) url.searchParams.append('lastName', searchValue.lastName);
    if (searchValue.email) url.searchParams.append('email', searchValue.email);
    if (searchValue.tel) url.searchParams.append('tel', searchValue.tel);
    if (searchValue.code) url.searchParams.append('code', searchValue.code);
    if (searchValue.merchantIds) for (const merchantId of searchValue.merchantIds) url.searchParams.append('merchantId', merchantId);
    if (searchValue.landlordIds) for (const landlordId of searchValue.landlordIds) url.searchParams.append('landlordId', landlordId);
    if (searchValue.createdAfter) url.searchParams.append('createdAfter', searchValue.createdAfter.startOf('day').toISOString());
    if (searchValue.createdBefore) url.searchParams.append('createdBefore', searchValue.createdBefore.endOf('day').toISOString());

    const res = await fetch(url, {
      headers: { 'X-ACCESS-TOKEN': accessToken },
    });
    if (res.ok) {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(await res.blob());
      a.download = `Coupon-Point-Report_${new Date().toISOString()}.xlsx`;
      a.click();
    } else {
      if (res.status === 404) {
        notification["error"]({
          message: "No matched discount found",
        });
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setLoading(false);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2 space-x-4">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconReport /> &nbsp;&nbsp;Coupon&point Report
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="">
          <Form
            form={form}
            layout="vertical"
            onFinish={download}
          >
            <Row align="middle" gutter={16}>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Name"
                  name="firstName"
                  colon={false}
                  initialValue={null}
                >
                  <Input
                    placeholder="Name"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Surname"
                  name="lastName"
                  colon={false}
                  initialValue={null}
                >
                  <Input
                    placeholder="Surname"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Email"
                  name="email"
                  colon={false}
                  initialValue={null}
                >
                  <Input
                    placeholder="Email"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Mobile Number"
                  name="tel"
                  colon={false}
                  initialValue={null}
                >
                  <Input
                    placeholder="Mobile Number"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Code"
                  name="code"
                  colon={false}
                  initialValue={null}
                >
                  <Input
                    placeholder="Code"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="Cluster Name"
                  name="merchantIds"
                  colon={false}
                  initialValue={[]}
                >
                  <MerchantDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    setSelectedMerchants={(merchantIds) => form.setFieldsValue({ merchantIds })}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={6}>
                <Form.Item
                  label="Site Name"
                  name="landlordIds"
                  colon={false}
                  initialValue={[]}
                >
                  <LandlordDropdown
                    allowClear
                    allowSearch
                    mode="multiple"
                    merchantIds={selectedMerchants}
                    setSelectedLandlords={(landlordIds) => form.setFieldsValue({ landlordIds })}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Redeem Date From"
                  name="createdAfter"
                  colon={false}
                  initialValue={null}
                >
                  <DatePicker
                    placeholder="Redeem Date From"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={4}>
                <Form.Item
                  label="Redeem Date To"
                  name="createdBefore"
                  colon={false}
                  initialValue={null}
                >
                  <DatePicker
                    placeholder="Redeem Date To"
                    allowClear
                    className="w-full"
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={24}>
                <div className="flex">
                  <Button
                    className="w-28"
                    type="primary"
                    shape="round"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    loading={loading}
                  >
                    Search
                  </Button>

                  <Button
                    className="w-28 ml-2"
                    type="primary"
                    ghost
                    shape="round"
                    htmlType="reset"
                    icon={<SyncOutlined />}
                  >
                    Clear Data
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default UserPromotionReport;
